import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-termos-de-uso',
  templateUrl: './modal-termos-de-uso.component.html',
  styleUrls: ['./modal-termos-de-uso.component.scss']
})
export class ModalTermosDeUsoComponent implements OnInit {
  public dataAtual = new Date();

  public months = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

  constructor(
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
  }

  public closeModalTermos(): void {
    this.activeModal.close();
  }

}
